import React, { useEffect, useState } from 'react';

const MultiFieldSuggestions = props => {
  const { controllers, text, onSuggestionClick = () => {} } = props;
  const [states, setStates] = useState(
    controllers.map(controller => controller.state)
  );

  useEffect(() => {
    controllers.forEach(controller =>
      controller.subscribe(() =>
        setStates(controllers.map(controller => controller.state))
      )
    );
  }, []);

  useEffect(() => {
    if (text === '') {
      controllers.forEach(controller => controller.clear());
      return;
    }
    controllers.forEach(controller => controller.updateText(text));
  }, [text]);

  return (
    <div className="coveo-headless-search-box__suggestions">
      {states.map((state, index) => {
        if (state.values.length === 0) return null;
        else
          return (
            <ul key={index}>
              {state.values.map(facetSearchValue => (
                <li
                  key={facetSearchValue.rawValue}
                  onClick={() =>
                    onSuggestionClick(facetSearchValue.displayValue)
                  }
                >
                  {facetSearchValue.displayValue}
                </li>
              ))}
            </ul>
          );
      })}
    </div>
  );
};

export default MultiFieldSuggestions;
